import { render } from "./editPersonalSettings.vue?vue&type=template&id=de0db69c"
import script from "./editPersonalSettings.vue?vue&type=script&lang=js"
export * from "./editPersonalSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__